//MANTENIMIENTO DE ACTIVOS ✅

export const collectionAdministrationModule = {
    feature_code: 'FEAT-490',
    enabled: false,
    children: [
        {
            feature_code: 'FEAT-491',
            enabled: false,
        },
        {
            feature_code: 'FEAT-492',
            enabled: false,
        },
        {
            feature_code: 'FEAT-493',
            enabled: false,
        },
        {
            feature_code: 'FEAT-494',
            enabled: false,
        },
        {
            feature_code: 'FEAT-495',
            enabled: false,
            children: [
                {
                    feature_code: 'FEAT-498',
                    enabled: false,
                    children: [
                        {
                            feature_code: 'FEAT-501',
                            enabled: false,
                        },
                        {
                            feature_code: 'FEAT-502',
                            enabled: false,
                        },
                        {
                            feature_code: 'FEAT-503',
                            enabled: false,
                        },
                        {
                            feature_code: 'FEAT-504',
                            enabled: false,
                        },
                        {
                            feature_code: 'FEAT-505',
                            enabled: false,
                        },
                        {
                            feature_code: 'FEAT-506',
                            enabled: false,
                        },
                    ]
                },
                {
                    feature_code: 'FEAT-499',
                    enabled: false,
                },
                {
                    feature_code: 'FEAT-500',
                    enabled: false,
                },
            ]
        },
        {
            feature_code: 'FEAT-496',
            enabled: false,
        },
        {
            feature_code: 'FEAT-497',
            enabled: false,
        },
    ]
}